import React from 'react';
import PortfolioSection from '../components/PortfolioSection';

const Portfolio: React.FC = () => {
  return (
    <div className="pt-20">
      <PortfolioSection />
    </div>
  );
};

export default Portfolio;
